import React from "react";
import styles from "./SearchTopTeaser.module.scss";
import { translateService } from "../../services/TranslateService";

type TopLevelTeaserProps = {
    mobileDevice: boolean;
    rootUrl: string;
};

const teaserTexts = [
    "vehicleSearch1.teaserText1",
    "vehicleSearch1.teaserText2",
    "vehicleSearch1.teaserText3",
];

const TopLevelTeaser: React.FC<TopLevelTeaserProps> = ({ mobileDevice, rootUrl }) => (
    <div className={styles.topLevelTeaser}>
        <h2 className={styles.topTeaserHeading}>
            {translateService.translate("vehicleSearch1.topTeaserHeading")}
        </h2>
        <div className={`${styles.topLevelItems} ${!mobileDevice ? styles.desktopPaddingBottom : ""}`}>
            {[0, 1].map((i) => (
                <div className={styles.teaserItemCol} key={i}>
                    <div className={styles.teaserItem}>
                        <img
                            src={rootUrl + "/assets/icons/new/circle-with-check.svg"}
                            alt={`topText${i + 1}`}
                            className={styles.teaserIcon}
                        />
                        <span>{translateService.translate(teaserTexts[i])}</span>
                    </div>
                </div>
            ))}
            {!mobileDevice && (
                <div className={styles.teaserItemCol3}>
                    <div className={styles.teaserItem}>
                        <img
                            src={rootUrl + "/assets/icons/new/circle-with-check.svg"}
                            alt="topText3"
                            className={styles.teaserIcon}
                        />
                        <span>{translateService.translate(teaserTexts[2])}</span>
                    </div>
                </div>
            )}
        </div>
    </div>
);

export default TopLevelTeaser;